/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ModerationResult } from './model/moderationResult';

export const apiModerationResultDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ModerationResult>({
    url: `/api/v7/moderation/result/${opk}/`,
    method: 'GET',
    signal,
  });
};

export const getApiModerationResultDetailRetrieveQueryKey = (opk?: string) => {
  return [`/api/v7/moderation/result/${opk}/`] as const;
};

export const getApiModerationResultDetailRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiModerationResultDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiModerationResultDetailRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiModerationResultDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiModerationResultDetailRetrieve>>> = ({
    signal,
  }) => apiModerationResultDetailRetrieve(opk, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiModerationResultDetailRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiModerationResultDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiModerationResultDetailRetrieve>>
>;
export type ApiModerationResultDetailRetrieveQueryError = ErrorType<unknown>;

export function useApiModerationResultDetailRetrieve<
  TData = Awaited<ReturnType<typeof apiModerationResultDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiModerationResultDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiModerationResultDetailRetrieveQueryOptions(opk, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
